import { APIS } from '../constants/apis';
import { CHAT_GPT_REQ } from '../constants/chatGPT';

export const fetchGPTResponse = async (messages) =>
  await fetch(APIS.chatGpt, {
    method: 'POST',
    body: JSON.stringify({
      messages: messages,
      ...CHAT_GPT_REQ,
    }),
    headers: {
      Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
      'Content-Type': 'application/json',
    },
  });
